import { ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1be40984"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "filter-content"
};
const _hoisted_2 = {
  class: "filter-list-content"
};
const _hoisted_3 = {
  class: "input-select-content"
};
const _hoisted_4 = {
  class: "filter-list"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "通知标题", -1));
const _hoisted_6 = {
  class: "filter-list"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "创建时间", -1));
const _hoisted_8 = {
  class: "filter-list"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "发送时间", -1));
const _hoisted_10 = {
  class: "filter-list"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "发送状态", -1));
const _hoisted_12 = {
  class: "btn-content"
};
import { onMounted } from '@vue/runtime-core';
import { statusList } from '@/common/dataJson/systemNotification';
export default /*#__PURE__*/_defineComponent({
  __name: 'NotificaFilterBlock',
  emits: ['filterSubmit', 'setProductName'],
  setup(__props, {
    emit
  }) {
    const notificationName = ref(''); // 通知标题
    const createTime = ref([]); // 创建时间
    const sendTime = ref([]); // 发送时间
    const sendStatus = ref(null); // 发送状态
    const filterSubmit = () => {
      let params = {
        sendStatus: sendStatus.value || '',
        title: notificationName.value,
        createTime: createTime.value,
        sendTime: sendTime.value
      };
      emit('filterSubmit', params);
    }; // 搜索
    const init = () => {
      notificationName.value = '';
      createTime.value = [];
      sendTime.value = [];
      sendStatus.value = null;
      filterSubmit();
    }; // 初始化
    onMounted(() => {
      init();
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_range_picker = _resolveComponent("a-range-picker");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_a_input, {
        value: notificationName.value,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => notificationName.value = $event),
        valueModifiers: {
          trim: true
        },
        placeholder: "请输入"
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createVNode(_component_a_range_picker, {
        value: createTime.value,
        "onUpdate:value": _cache[1] || (_cache[1] = $event => createTime.value = $event)
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_a_range_picker, {
        value: sendTime.value,
        "onUpdate:value": _cache[2] || (_cache[2] = $event => sendTime.value = $event)
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createVNode(_component_a_select, {
        value: sendStatus.value,
        "onUpdate:value": _cache[3] || (_cache[3] = $event => sendStatus.value = $event),
        placeholder: "请选择",
        options: _unref(statusList)
      }, null, 8, ["value", "options"])])]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_a_button, {
        onClick: init
      }, {
        default: _withCtx(() => [_createTextVNode("重置")]),
        _: 1
      }), _createVNode(_component_a_button, {
        type: "primary",
        onClick: filterSubmit
      }, {
        default: _withCtx(() => [_createTextVNode("搜索")]),
        _: 1
      })])])]);
    };
  }
});